<template>
  <div class="page flex">
    <app-header class="header flex0" ref="header" title="我的资料">
      <i slot="back"></i>
    </app-header>
    <div class="main overflow-y-auto" ref="main">
      <!--<uploader @uploaded="uploaded" ref="uploader"></uploader>-->
      <div class="wrap flex">
        <div class="label flex1">
          头像
        </div>
        <div class="text flex0 ava">
          <img :src="patAva(userInfo)" data-kdkkd="" :data-gender="userInfo.patGender" @error="__avaError($event)"
               alt=""
               @click="uploadImg">
        </div>
      </div>

      <!--      <div class="auth wrap flex" @click="handleRealName(sysCommonPatVo.isRealnameAuth)">
              <div class="label flex0">
                实名认证
              </div>
              <div class="text flex1">
                <span
                  :class="[sysCommonPatVo.isRealnameAuth?'ok':'no']">{{
                    sysCommonPatVo.isRealnameAuth ? "已认证" : "未认证"
                  }}</span>
              </div>
            </div>-->

      <div class="title">
        个人信息
      </div>

      <div class="wrap flex" @click="edit('name',userInfo.patName)">
        <div class="label flex0">
          姓名
        </div>
        <div class="text flex1">
          {{ userInfo.patName }}
        </div>
      </div>

      <div class="wrap flex" @click="edit('card',userInfo.patIdcard)">
        <div class="label flex0">
          身份证
        </div>
        <div class="text flex1">
          {{ patIdcard }}
        </div>
      </div>

      <div class="wrap flex" @click="modifyPhone">
        <div class="label flex0">
          登录账号
        </div>
        <div class="text flex1">
          {{ userInfo.patMobile|formatCardAndMobile(3,4,4) }}
        </div>
      </div>

      <div class="wrap flex nobg">
        <div class="label flex0">
          年龄
        </div>
        <div class="text flex1">
          {{ userInfo.age }}
        </div>
      </div>

      <div class="wrap flex nobg">
        <div class="label flex0">
          性别
        </div>
        <div class="text flex1">
          {{ userInfo.patGender|getGender }}
        </div>
      </div>

      <!--      <div class="wrap flex" @click="modifyMaritalStatus">
              <div class="label flex0">
                婚姻状况
              </div>
              <div class="text flex1">
                {{ sysCommonPatVo.maritalStatus|getMaritalStatus }}
              </div>
            </div>-->

      <div @click="area" class="wrap flex">
        <div class="label flex0">
          所在地区
        </div>
        <div class="text flex1">
          {{ userInfo.patAreaname }}
        </div>
      </div>

      <!--      <div class="wrap flex nobg">
              <div class="label flex0">
                与我关系
              </div>
              <div class="text flex1">
                本人
              </div>
            </div>-->

      <!--      <div class="title">
              医院信息
            </div>

            <div v-for="hos in sysCommonPatVo.records" class="wrap flex" @click="handlerRecord(hos)">
              <div class="label flex0">
                {{ hos.hosName }}
              </div>
              <div class="text flex1">
                ({{ hos.compatMedicalRecord }})
              </div>
            </div>
            <div class="wrap flex nobg">
              <router-link :to="{path:'/hospital',query:{action:'auth',compatId:sysCommonPatVo.compatId}}"
                           class="add flex1 center">+添加医院账号
              </router-link>
            </div>-->
    </div>
    <!--<uploader @uploaded="uploaded" ref="uploader"></uploader>-->
    <tailoring @uploaded="uploaded" ref="uploader"></tailoring>
  </div>
</template>

<script>
import AppHeader from "../../plugins/app-header.vue"
import {avaErrorMixin, isBindMixin, mainHeightMixin} from "@/lib/mixin"
import patAva from "../../utils/patAva"
import getSex from "../../utils/getSex"
import {getGender, getMaritalStatus, formatCardAndMobile} from "@/lib/filter";
import api from "../../lib/api"
import weuijs from "weui.js"
import Uploader from "../../plugins/upload.vue"
import getArea from "../../utils/formatArea"
import Tailoring from "../../plugins/tailoring"
import {maritalStatus} from "@/lib/config";
import {RecordMixin} from "@/lib/mixins/record";

export default {
  mixins: [isBindMixin, mainHeightMixin, avaErrorMixin, RecordMixin],
  data() {
    return {
      userInfo: {}
    };
  },
  filters: {
    getGender, getMaritalStatus,
    formatCardAndMobile
  },
  computed: {
    /*sysCommonPatVo() {
      return this.userInfo.sysCommonPatVo ? this.userInfo.sysCommonPatVo : {}
    },*/
    patIdcard() {
      const idCard = this.userInfo.patIdcard;
      if (idCard) {
        return formatCardAndMobile(idCard, 6, 4, 8)
      }
      return "缺失"
    }
  },
  components: {
    AppHeader, Uploader, Tailoring
  },
  async created() {
    let res = await this._isBind()
    if (typeof res === 'object') {
      if (res.patAreacode && !res.patAreaname) {
        res.patAreaname = await getArea(res.patAreacode, "text");
      }
      this.userInfo = res;
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  watch: {
    'userInfo.patAreacode': {
      handler(newV) {
        getArea(newV, 'text').then(data => this.$set(this.userInfo, 'patAreaname', data));
      }
    }
  },


  methods: {
    patAva, getSex,
    async area() {
      let that = this;
      let container = "body", list = await getArea(), defaultValue = this.userInfo.patAreacode;
      defaultValue && (defaultValue = await getArea(this.userInfo.patAreacode, 'code'))
      let options = {
        container,
        defaultValue,
        onConfirm(arr) {
          that.modify({
            patAreacode: arr[2].value
          })
        }
      }
      weuijs.picker(list, options)
    },
    edit(type, value) {
      // value = '';
      if (!value && type === 'card') {
        this._toPerfectPage();
        return
      }
      this.$router.push({
        path: "/my/edit",
        query: {
          service: "nethos.pat.info.modify.v2",
          mode: type,
          value: value,
          id: this.userInfo.patId
        }
      })
    },
    uploaded(ret) {
      if (ret.code == 0) {
        let form = {
          patAvatar: ret.obj.attaId
        }
        this.modify(form);
      }
    },
    async modify(form) {
      let loading = weuijs.loading("修改中...");
      let options = {
        patId: this.userInfo.patId,
        supplementStatus: false
      }
      options = Object.assign({}, options, form);
      let ret = await api("nethos.pat.info.modify.v2", options);
      loading.hide();
      if (ret.code == 0) {
        let userInfo = Object.assign({}, this.userInfo, ret.obj);
        this.userInfo = userInfo;
      }
      setTimeout((res) => {
        weuijs.toast("修改成功");
      }, 200)
    },
    uploadImg() {
      //let dom = this.$refs.tailoring.$el;
      let dom = this.$refs.uploader.$el;
      dom.querySelector("input").click();
    },
    modifyPhone() {
      this.$router.push("/changePhone")
      /*let msg = "\n" +
        "\n" +
        "修改手机号将同时更改您的登录手机号；\n" +
        "\n" +
        "并导致运营商认证、医院认证、医院帐号绑定失效，确定吗？\n";
      weuijs.confirm(msg,
        () => {

        })*/
    },
    modifyMaritalStatus() {
      this.$weuijs.picker(maritalStatus, {
        container: 'body',
        onConfirm: (arr) => {
          this.modify({
            maritalStatus: maritalStatus.findIndex(r => r === arr[0].value)
          })
        }
      });
    },
    /*handleRealName(isRealnameAuth) {
      let query = {
        compatId: this.sysCommonPatVo.compatId
      }
      this.$router.push({
        path: "/my/auth",
        query: query
      })
    },*/
  }
};
</script>

<style scoped lang="scss">
@import "../../common/public";

%column {
  flex-direction: column;
}

.page {
  @extend %column;

  .wrap + .wrap {
    @include border(top);
  }

  .auth {
    .ok {
      color: $mainColor;
    }

    .no {
      color: red;
    }
  }

  .title {
    background-color: $bgColor;
    padding: 10px 1rem;
  }

  .wrap {
    background-image: url("../../../static/img/more.png");
    @include backgroundImageSet(17px/2, 30px/2, 19rem);
    padding: 15px 1.5rem 15px 1rem;
    align-items: center;
    line-height: 1;

    &.nobg {
      background: none;
    }

    .label {
      font-size: 17px;
    }

    .text {
      text-align: right;
      color: #999999;
    }

    .add {
      color: $mainColor;
    }
  }

  .ava {
    @include ava(50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/my/data.vue